import * as React from "react";
import Box from "@mui/material/Box";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { ModuleMenuItem } from "./ModuleMenuItem";
import logoLight from "../../utils/assets/logoLight.png";
import logoMobileDark from "../../utils/assets/logoMobileDark.png";

const Nav = styled(List)<{ component?: React.ElementType }>({
  "& .MuiListItemButton-root": {
    paddingLeft: 24,
    paddingRight: 24,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    marginRight: 16,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 20,
  },
});
const ScrollingMenuSection = styled("div")({
  overflowY: "auto",
  height: "calc(100vh - 184px)", // Adjust the height to fit your layout
});
export interface MenuProps {
  handleDrawerClose: () => void;
}

export default function Menu(props: MenuProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const closeMenu = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
      <ThemeProvider
        theme={createTheme({
          components: {
            MuiListItemButton: {
              defaultProps: {
                disableTouchRipple: true,
              },
            },
          },
          palette: {
            mode: theme.palette.mode,
            background: {
              paper:
                theme.palette.mode === "dark"
                  ? "rgb(37, 37, 38)"
                  : "rgb(255, 255, 255)",
            },
          },
        })}
      >
        <Paper
          elevation={0}
          sx={{
            maxWidth: 300,
            minWidth: 300,
            [theme.breakpoints.down("md")]: {
              maxWidth: "100%",
              minWidth: "100%",
            },
            borderRadius: 0,
          }}
        >
          <Nav component="nav" disablePadding>
            <Stack direction="row" justifyContent="flex" alignItems="center">
              <Button
                onClick={() => {
                  navigate("/reversal");
                  closeMenu && props.handleDrawerClose();
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexGrow: 1,
                  minHeight: 64,
                }}
              >
                <Box
                  component="img"
                  src={
                    theme.palette.mode === "dark" ? logoMobileDark : logoLight
                  }
                  alt="ArcosDourados"
                  height="47px"
                />
              </Button>

              <IconButton onClick={props.handleDrawerClose}>
                {theme.direction === "rtl" ? <ChevronRight /> : <ChevronLeft />}
              </IconButton>
            </Stack>
            <Divider />

            <ScrollingMenuSection sx={{ pb: 5 }}>
              <ModuleMenuItem
                closeMenu={closeMenu}
                handleDrawerClose={props.handleDrawerClose}
              />
            </ScrollingMenuSection>
          </Nav>
        </Paper>
      </ThemeProvider>
    </Box>
  );
}
